<template>

 <div class="container">
     <div class="row px-0 py-3 m-0 border-bottom border-light d-none d-lg-flex">
        <div class="col-10 col-lg-2 text-start p-0 m-0 m-auto">
            <localized-link to="/">
                <img :src="`${publicPath}img/logoMutua.gif`" class="img-responsive">
            </localized-link>
        </div>
        <language-switcher class="col-8 col-lg-10 text-end d-none d-lg-block" v-slot="{ links }" tag="div">
            <a v-for="link in links" :key="link.langIndex"
               :class="link.activeClass"
                :href="` https://memorias.mutuauniversal.net/export/2021${link.url}`"
                class="mx-2"
            >
                <span v-if="link.langIndex=='es'">Cas.</span>
                <span v-if="link.langIndex=='ca'">Cat.</span>
                <span v-if="link.langIndex=='en'">Eng.</span>
                <span v-if="link.langIndex=='eu'">Eus.</span>
                <span v-if="link.langIndex=='ga'">Gal.</span>
            </a>
          <download-file
              title=""
              :showtitle="false"
              :file= download_file
              class="justify-content-end" />
            <localized-link to="/" class="ms-2"></localized-link>
        </language-switcher>
     </div>

     <nav class="navbar navbar-expand-lg p-0 m-0">
         <div class="container-fluid d-block d-sm-block d-md-block d-lg-none border-bottom border-light bocata  mb-2">
             <div class="row align-items-center py-3">
                 <div class="col-10 col-lg-2 text-start">
                     <localized-link to="/">
                         <img :src="`${publicPath}img/logoMutua.gif`" class="img-responsive">
                     </localized-link>
                 </div>
                 <div class="col-2 text-end">
                     <a class="" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                         <i class="fa fa-bars"></i>
                     </a>
                 </div>
             </div>
         </div>
             <div class="collapse navbar-collapse p-0 m-0" id="collapseExample">
                 <ul class="container-fluid navbar-nav g-0 p-0 m-0">
                     <li class="col-auto align-top text-start text-lg-center p-3 p-lg-0 pe-0 pe-lg-3 mt-2 mb-0 mb-lg-3">
                         <strong>{{ $t("nav.informe")}}</strong>
                     </li>
                     <li class="col nav-item text-start text-lg-center dropdown px-0">
                         <localized-link class="nav-link align-top border-start  p-0 px-3 px-lg-2 mt-1 mt-lg-2 mb-1 mb-lg-3" to="/cartas"  data-target="/cartas">{{ $t("nav.cartas") }}</localized-link>
                         <ul class="dropdown-menu m-0 p-0 p-lg-4">
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/cartas/carta-del-presidente">{{ $t("nav.carta-del-presidente") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/cartas/carta-del-director-gerente">{{ $t("nav.carta-del-director-gerente") }}</localized-link></li>
                         </ul>
                     </li>
                     <li class="col nav-item text-start text-lg-center dropdown px-0">
                         <localized-link class="nav-link align-top border-start p-0 px-3 px-lg-2 mt-1 mt-lg-2 mb-1 mb-lg-3"  to="/plan-estrategico"  data-target="/plan-estrategico">{{ $t("nav.plan-estrategico") }}</localized-link>
                     </li>
                     <li class="col nav-item text-start text-lg-center dropdown px-0">
                         <localized-link class="nav-link align-top border-start p-0 px-3 px-lg-2 mt-1 mt-lg-2 mb-1 mb-lg-3" to="/nuestra-actuacion-en-2021" data-target="/nuestra-actuacion-en-2021" v-html="$t('nav.nuestra-actuacion-en-2021')"></localized-link>
                         <ul class="dropdown-menu m-0 p-0 p-lg-4">
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/nuestra-actuacion-en-2021/2021-en-resumen">{{ $t("nav.2021-en-resumen") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/nuestra-actuacion-en-2021/asistencia-sanitaria-personalizada">{{ $t("nav.asistencia-sanitaria-personalizada") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/nuestra-actuacion-en-2021/acciones-de-prevencion">{{ $t("nav.acciones-de-prevencion") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/nuestra-actuacion-en-2021/tecnologia-al-servicio-de-las-personas">{{ $t("nav.tecnologia-al-servicio-de-las-personas") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/nuestra-actuacion-en-2021/organizacion-y-buen-gobierno">{{ $t("nav.organizacion-y-buen-gobierno") }}</localized-link></li>
                         </ul>
                     </li>
                     <li class="col nav-item text-start text-lg-center dropdown px-0">
                         <localized-link class="nav-link align-top border-start p-0 px-3 px-lg-2 mt-1 mt-lg-2 mb-1 mb-lg-3" to="/sostenibilidad"  data-target="/sostenibilidad" v-html="$t('nav.sostenibilidad')"></localized-link>
                         <ul class="dropdown-menu m-0 p-0 p-lg-4">
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/sostenibilidad/plan-de-rsc-y-sostenibilidad-21-24">{{ $t("nav.plan-de-rsc-y-sostenibilidad-21-24") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/sostenibilidad/nuestra-contribucion-a-los-ods">{{ $t("nav.nuestra-contribucion-a-los-ods") }}</localized-link></li>
                             <li><localized-link class="dropdown-item py-2 ps-4 ps-lg-0 text-start" to="/sostenibilidad/impacto-en-el-entorno">{{ $t("nav.impacto-entorno") }}</localized-link></li>
                         </ul>
                     </li>
                     <li class="col nav-item text-start text-lg-end dropdown px-0">
                         <localized-link class="nav-link align-top border-start p-0 px-3 px-lg-2 mt-1 mt-lg-2 mb-1 mb-lg-3" to="#"  data-target="#">{{ $t('nav.memorias_anteriores')}} <i class="fa fa-arrow-down ms-2"></i> </localized-link>
                         <ul class="dropdown-menu m-0 p-0 p-lg-4">
                             <li><a :href="url_2020" class="dropdown-item py-2 ps-4 ps-lg-0 text-start" target="_blank">2020</a></li>
                             <li><a :href="url_2019" class="dropdown-item py-2 ps-4 ps-lg-0 text-start" target="_blank">2019</a></li>
                             <li><a :href="url_2018" class="dropdown-item py-2 ps-4 ps-lg-0 text-start" target="_blank">2018</a></li>
                             <li><a :href="url_2017" class="dropdown-item py-2 ps-4 ps-lg-0 text-start" target="_blank">2017</a></li>
                         </ul>
                     </li>
                     <li class="col nav-item text-center px-0 d-block d-lg-none py-3">
                         <language-switcher class="col-12 text-center" v-slot="{ links }" tag="div">
                             <a v-for="link in links" :key="link.langIndex"
                                :class="link.activeClass"
                                :href="link.url"
                                class="mx-2"
                             >
                                 <span v-if="link.langIndex=='es'">Cas.</span>
                                 <span v-if="link.langIndex=='ca'">Cat.</span>
                                 <span v-if="link.langIndex=='en'">Eng.</span>
                                 <span v-if="link.langIndex=='eu'">Eus.</span>
                                 <span v-if="link.langIndex=='ga'">Gal.</span>
                             </a>
                         </language-switcher>
                     </li>
                 </ul>
             </div>
     </nav>

 </div>
</template>

<script>
    import DownloadFile from "@/components/DownloadFile";
    export default {
        name: "NavigationView",
        components: {
            DownloadFile
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
                download_file:'MU_memoria_2021_es.pdf',
                url_2020 : 'https://memorias.mutuauniversal.net/export/2020/index.html',
                url_2019 : 'https://memorias.mutuauniversal.net/export/2019/index.html#/cas/memoria-anual-2019-cas',
                url_2018 : 'https://memorias.mutuauniversal.net/2018/es/index.html',
                url_2017 : 'https://memorias.mutuauniversal.net/2017/es/index.html'
            }
        },
        created() {
            // Remove show class from collapsible element to close movile menu
            this.$router.afterEach(() => {
                var element = document.getElementById("collapseExample");
                element.classList.remove("show");
              switch (this.$i18n.locale) {
                case 'es':
                  this.url_2020 = 'https://memorias.mutuauniversal.net/export/2020/index.html';
                  this.url_2019 ='https://memorias.mutuauniversal.net/export/2019/index.html#/cas/memoria-anual-2019-cas';
                  this.url_2018 ='https://memorias.mutuauniversal.net/2018/es/index.html';
                  this.url_2017 ='https://memorias.mutuauniversal.net/2017/es/index.html';
                  this.download_file='MU_memoria_2021_es.pdf';
                  break;
                case 'ca':
                  this.url_2020 = 'https://memorias.mutuauniversal.net/export/2020/index.html';
                  this.url_2019 ='https://memorias.mutuauniversal.net/export/2019/index.html#/cat/memoria-anual-2019-cat';
                  this.url_2018 ='https://memorias.mutuauniversal.net/2018/ca/index.html';
                  this.url_2017 ='https://memorias.mutuauniversal.net/2017/ca/index.html';
                  this.download_file='MU_memoria_2021_ca.pdf';
                  break;
                case 'en':
                  this.url_2020 = 'https://memorias.mutuauniversal.net/export/2020/index.html';
                  this.url_2019 ='https://memorias.mutuauniversal.net/export/2019/index.html#/eng/annual-report-2019-eng';
                  this.url_2018 ='https://memorias.mutuauniversal.net/2018/en/index.html';
                  this.url_2017 ='https://memorias.mutuauniversal.net/2017/en/index.html';
                  this.download_file='MU_memoria_2021_es.pdf';
                  break;
                case 'ga':
                  this.url_2020 = 'https://memorias.mutuauniversal.net/export/2020/index.html';
                  this.url_2019 ='https://memorias.mutuauniversal.net/export/2019/index.html#/gal/memoria-anual-2019-gal';
                  this.url_2018 ='https://memorias.mutuauniversal.net/2018/gl/index.html';
                  this.url_2017 ='https://memorias.mutuauniversal.net/2017/gl/index.html';
                  this.download_file='MU_memoria_2021_es.pdf';
                  break;
                case 'eu':
                  this.url_2020 ='https://memorias.mutuauniversal.net/export/2020/index.html';
                  this.url_2019 ='https://memorias.mutuauniversal.net/export/2019/index.html#/eus/urteko-memoria-2019-eus';
                  this.url_2018 ='https://memorias.mutuauniversal.net/2018/eu/index.html';
                  this.url_2017 ='https://memorias.mutuauniversal.net/2017/eu/index.html';
                  this.download_file='MU_memoria_2021_es.pdf';
                  break;
                default:
                  console.log('default');
              }

                this.locale = this.$i18n.locale;

            });
        },
    };
</script>

